import React, { EventHandler, SyntheticEvent} from "react";
import {moneyToInt} from "../utils";
import NumberFormat, {InputAttributes} from "react-number-format";
import { ExchangeRatesContext } from '../contexts/exchange-rates-context';
import { asMoney2, asMoneyWithDivisor } from '../utils/index';
import {TextField} from "@mui/material";
import { RoomPreferencesSharp } from "@mui/icons-material";
import { Currency } from "../generated/graphql";



interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
}

type EventHandler = (evt:SyntheticEvent) => void;

export function CurrencyField(props)  {
    console.log('CF1 - FIELD',props);
    const variant = props.fill?'standard':props.variant;
    return <TextField
        {...props}
        variant={variant}
        multiline={false}
        InputLabelProps={{ shrink: true }}
        inputProps={{
            ...props
        }}
        InputProps={{
            inputComponent: CurrencyFormatCustom as any,

        }}
    />
}

const CurrencyFormatCustom = React.forwardRef<
    NumberFormat<InputAttributes>,
    CustomProps
    >(function CurrencyInputRef(props:{
    name: string,
    value: number,
    autoFocus: boolean,
    onChange: Function,
    allowContextCurrency?: boolean,
    onBlur?: EventHandler,
    className?: string,
    loading?:boolean,
    readOnly?: boolean
},ref) {
    const doChange = (evt)=>{
        console.log('bubbleup changes',evt);
        props.onChange({target:{name:evt.target.name,value:evt.target.value},currentTarget:{name:evt.target.name,value:evt.target.value}});
    }
    console.log('CF1 - CUSTOM',props);
    return <CurrencyInput
        {...props}
        onChange={doChange}
        className={[(props.className??'')].join(' ')}
        getInputRef={ref}
    />;
});



function convertToDivisor(input) {
    let val = input.replace(/[^0-9\.]/g,'');
    val = val?.replace(/^0+|\.0+$/g, '');
    // eslint-disable-next-line prefer-const
    let [intVal,remVal] = val.split('.');
    intVal = parseInt(intVal,10)??0;
    if(!remVal) remVal = '';
    const offset = remVal?.length??0;
    if(offset==1) {
        remVal+='0';
    }
    if(offset==0) {
        remVal+='00';
    }
    const divisor = Math.pow(10,remVal.length-2??0);
    const value = ((intVal>0?intVal.toString():'')+(remVal??'')).replace(/^0+/,'');
    return ({divisor:divisor,value:value});
}


const CurrencyInput = (props:{
    currencySelect?:boolean,
    currencyAccessor?:string,
    currency?:any,
    readOnly?:boolean,
    value:number|string,
    autoFocus?:boolean,
    placeholder?:string,
    currencyValueIsId?:boolean,
    name:string,
    error?:string,
    allowContextCurrency?:boolean
    onChange:EventHandler<any>,
    className?:string,
    divisorAccessor?:string,
    getInputRef?:any,
    divisor?:number,
    raw?:boolean,
    places?:number,
    showGlyph?:boolean
}) => {
    console.log('CF1','INPUT',props);
    const exchangeRatesContext = React.useContext(ExchangeRatesContext);
    //const [value,setValue] = useState(props.value?.toString());
    const onChange = (v) => {
        const rawVal = v.currentTarget?.value??v.target.value;
        if(props.divisorAccessor) {
            const result = convertToDivisor(rawVal);
            console.log('PDIV SET VALUE',result,props.name);
            props.onChange({target:{name:props.name,value:parseInt(result.value,10)}});
            props.onChange({target:{name:props.divisorAccessor,value:result.divisor}});
            //props.field.setValue(props.rowName+'.campaignComponent.unit_value_local',intValue);    }
            return;
        }
        const val = !props.raw?moneyToInt((rawVal).replace(/[^0-9\.]/g,'')):rawVal;
        props.onChange({target: {name: props.name, value: val,type:'value'}});
        //setValue(rawVal);
    };
    let currencySelector:any = [];
    if(props.currencySelect && (exchangeRatesContext?.options?.length>1)) {
//    let currencyName:any = props.name.split('.');
        //currencyName.pop();
        //currencyName.push('currency');
        //currencyName = currencyName.join('.');
        const options = exchangeRatesContext?.options?.map((v)=>(<option value={v.id} key={v.id}>{v.glyph}</option>))??[];
        if(props.allowContextCurrency) {
            options.unshift(<option value={undefined} style={{fontWeight:'bold'}} key="default">{exchangeRatesContext?.targetCurrency?.glyph}</option>);
        }
        const onChangeCurrency = (v) => {
            const val = parseInt(v.currentTarget.value,10);
            if(props.currencyValueIsId) {
                props.onChange({target: {name: props.currencyAccessor, value: val,type:'currency'}});
                return;
            }
            let selectedItem:any = null;
            exchangeRatesContext?.options?.forEach((option)=>{
                if(val==option?.id) {
                    selectedItem = option;
                }
            });
            props.onChange({target: {name: props.currencyAccessor, value: selectedItem,type:'currency'}});
        };
        if(props.currencyValueIsId) {
            currencySelector = <select value={props.currency} onChange={onChangeCurrency}>{options}</select>;
        } else {
            currencySelector = <select value={props.currency?.id} onChange={onChangeCurrency}>{options}</select>;
        }
    } else {
        currencySelector = null;
    }
    let currency:Currency|undefined|null = null;
    if(props.currencyValueIsId) {
        currency = exchangeRatesContext?.options.find((option)=>option.id==props.currency);
    } else {
        currency = props.currency;
    }
    if(!currency) {
        if(!currencySelector) {
            currency = exchangeRatesContext?.targetCurrency;
        }
    }
    console.log('currencyeditor is',currency,props.currencySelect,exchangeRatesContext,currencySelector?'':currency?.glyph);
//  const renderValue = (moneyToInt(value)!==props.value)?asMoney2(props.value,props.places??2):value;
    let renderValue = '';
    if(props.divisor) {
        renderValue = asMoneyWithDivisor({value:props.value,divisor:props.divisor,places:0});
    } else {
        renderValue = asMoney2(props.value,2);
    }
    return (<>{currencySelector}<NumberFormat
        name={props.name}
        value={renderValue}
        getInputRef={props.getInputRef}
        prefix={currencySelector ? '' : (props.showGlyph ? currency?.glyph : '')}
        readOnly={props.readOnly}
        thousandSeparator=","
        size={(props.value?.length??0)+2}
        decimalScale={props.places??undefined}
        allowNegative={false}
        style={{textAlign:'right'}}
        onFocus={(evt)=>evt.target.select()}
        autoFocus={props.autoFocus}
        className={props.className??''}
        onChange={onChange}
        placeholder={props.placeholder?props.placeholder:''}
    /></>);

}

export default CurrencyInput;
